import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../service/login/login.service';
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-central-services',
  templateUrl: './central-services.component.html',
  styleUrls: ['./central-services.component.css']
})
export class CentralServicesComponent implements OnInit {

  leftMenu1 = true;
  leftMenu2 = false;
  leftMenu3 = false;
  leftMenu4 = false;
  leftMenu5 = false;
  leftMenu6 = false;
  leftMenu7 = false;


  constructor(private service: LoginService, private router: Router) { }

  ngOnInit() {

  }

  intro(num: number) {
    switch (num) {
      case 1:
        localStorage.setItem('type', "卫星遥感数据分发")
        this.router.navigate(["/centralServices/dataIntroduce"])
        this.leftMenu1 = true
        this.leftMenu2 = false
        this.leftMenu3 = false
        this.leftMenu4 = false
        this.leftMenu5 = false
        this.leftMenu6 = false
        this.leftMenu7 = false
        break
      case 2:
        localStorage.setItem('type', "海量遥感数据预处理")
        this.router.navigate(["/centralServices/nature"])
        this.leftMenu1 = false
        this.leftMenu2 = true
        this.leftMenu3 = false
        this.leftMenu4 = false
        this.leftMenu5 = false
        this.leftMenu6 = false
        this.leftMenu7 = false
        break
      case 3:
        localStorage.setItem('type', "批量遥感数据信息提取")
        this.router.navigate(["/centralServices/production"])
        this.leftMenu1 = false
        this.leftMenu2 = false
        this.leftMenu3 = true
        this.leftMenu4 = false
        this.leftMenu5 = false
        this.leftMenu6 = false
        this.leftMenu7 = false
        break
      case 4:
        localStorage.setItem('type', "空间信息综合分析")
        this.router.navigate(["/centralServices/spaceInfo"])
        this.leftMenu1 = false
        this.leftMenu2 = false
        this.leftMenu3 = false
        this.leftMenu4 = true
        this.leftMenu5 = false
        this.leftMenu6 = false
        this.leftMenu7 = false
        break
      case 5:
        localStorage.setItem('type', "“天空地”一体化监测")
        this.router.navigate(["/centralServices/skyLand"])
        this.leftMenu1 = false
        this.leftMenu2 = false
        this.leftMenu3 = false
        this.leftMenu4 = false
        this.leftMenu5 = true
        this.leftMenu6 = false
        this.leftMenu7 = false
        break
      case 6:
        localStorage.setItem('type', "综合遥感制图表达")
        this.router.navigate(["/centralServices/complexMapping"])
        this.leftMenu1 = false
        this.leftMenu2 = false
        this.leftMenu3 = false
        this.leftMenu4 = false
        this.leftMenu5 = false
        this.leftMenu6 = true
        this.leftMenu7 = false
        break
      case 7:
        localStorage.setItem('type', "3S空间地理信息综合应用")
        this.router.navigate(["/centralServices/threeS"])
        this.leftMenu1 = false
        this.leftMenu2 = false
        this.leftMenu3 = false
        this.leftMenu4 = false
        this.leftMenu5 = false
        this.leftMenu6 = false
        this.leftMenu7 = true
        break
    }

  }
}
